import api from "./api";

// --- Listagem e Consulta ---

/**
 * Retorna todas as associações (sem paginação).
 * GET /api/user-groups
 */
export function fetchAll() {
  return api.get("/user-groups");
}

/**
 * Retorna associações paginadas com suporte a busca.
 * GET /api/user-groups/paged
 */
export function fetchPaged(pageNumber, pageSize, search = "") {
  return api.get("/user-groups/paged", {
    params: {
      pageNumber,
      pageSize,
      search,
    },
  });
}

/**
 * Retorna uma associação específica por seu ID único.
 * GET /api/user-groups/{id}
 */
export function getById(id) {
  return api.get(`/user-groups/${id}`);
}

// --- Operações CRUD Individuais ---

/**
 * Cria uma nova associação entre um usuário e um grupo.
 * POST /api/user-groups
 * @param {object} data - { userId, groupId }
 */
export function create(data) {
  return api.post("/user-groups", data);
}

/**
 * Remove uma associação pelo seu ID único.
 * DELETE /api/user-groups/{id}
 */
export function removeById(id) {
  return api.delete(`/user-groups/${id}`);
}

// --- Operações em Lote ---

/**
 * Cria múltiplas associações a partir de uma lista de pares.
 * POST /api/user-groups/bulk-add/by-pairs
 * @param {Array<object>} pairs - [{ userId, groupId }, ...]
 */
export function bulkAddByPairs(pairs) {
  return api.post("/user-groups/bulk-add/by-pairs", pairs);
}

/**
 * Remove múltiplas associações a partir de uma lista de IDs de associação.
 * POST /api/user-groups/bulk-remove/by-ids
 * @param {Array<number>} ids - [141, 142, ...]
 */
export function bulkRemoveByIds(ids) {
  const payload = { userGroupIds: ids };
  return api.post("/user-groups/bulk-remove/by-ids", payload);
}

/**
 * Cria associações usando o método de produto cartesiano.
 * POST /api/user-groups/bulk-add/cartesian
 * @param {object} data - { userIds: [...], groupIds: [...] }
 */
export function bulkAddByCartesian(data) {
  return api.post("/user-groups/bulk-add/cartesian", data);
}

/**
 * Remove associações usando o método de produto cartesiano.
 * POST /api/user-groups/bulk-remove/cartesian
 * @param {object} data - { userIds: [...], groupIds: [...] }
 */
export function bulkRemoveByCartesian(data) {
  return api.post("/user-groups/bulk-remove/cartesian", data);
}
